<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <DemandTabLinks />
                    <DemandCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="$router.push(`/demands`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import DemandTabLinks from '@/components/demands/DemandTabLinks';
    import DemandCard from '@/components/demands/DemandCard';

    export default {
        name: 'Demand',

        components: {
            DemandTabLinks,
            DemandCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/demands/${id}`)).data;
            },
        },
    };
</script>
